import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/hearts.svg'


const _hoisted_1 = { class: "thankYou left" }
const _hoisted_2 = ["alt"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", { class: "primaryShort mb-15" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", { class: "grayWide" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _imports_0,
      alt: _ctx.$t('accessibility.payment.order'),
      class: "hearts"
    }, null, 8, _hoisted_2),
    _hoisted_3,
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t("connected_accounts.thank_you")), 1),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t("connected_accounts.successfully_connected")), 1),
    _hoisted_4,
    _createElementVNode("button", {
      class: "defaultButton whiteBG",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reset')))
    }, _toDisplayString(_ctx.$t("connected_accounts.connect_another")), 1),
    _createVNode(_component_router_link, {
      to: { name: 'RelatedAccounts' },
      class: "cancel"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("connected_accounts.finish")), 1)
      ]),
      _: 1
    })
  ]))
}